import {btn, comp, tbar, win} from "@intermesh/goui";
import {t} from "../util/Translate.js";

/**
 * Wrapper for the GOUI window class, but translations are retrieved from the proper class
 *
 */
export class IfwWindow extends Window {
	public static confirm(text: string, title: string = t("Please confirm")): Promise<boolean> {

		return new Promise((resolve) => {

			const w = win({
					modal: true,
					title: title,
					closable: false,
					width: 600,
					listeners: {
						focus: (w) => {
							w.findChild("no")!.focus();
						}
					}
				},

				comp({
					cls: "pad",
					html: text
				}),

				tbar({},
					'->',
					btn({
						itemId: "no",
						text: t("No"),
						handler: () => {
							resolve(false);
							w.close();
						}
					}),

					btn({
						itemId: "yes",
						text: t("Yes"),
						cls: "filled primary",
						handler: () => {
							resolve(true);
							w.close();
						}
					})
				)
			);

			w.show();
		});
	}
}
